import React from 'react';
import cx from 'classnames';
import { format } from 'date-fns';
import { pluralize } from 'js/utils/string';
import { snapshotDisplayName } from './org-snapshot-utils';

import { Link } from 'react-router-dom';
import { Icon } from 'js/components';

import {
  faBoxArchive,
  faCircleQuestion,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons';

import styles from './OrgSnapshots.module.scss';

function formatWhen(value) {
  if (!value) {
    return '—';
  }
  const d = new Date(value);
  return format(d, 'PPp');
}

export default function OrgSnapshotSetItem({ snapshot, to }) {
  const isArchived = snapshot.archived_state === 'archived';

  return (
    <li
      className={cx(styles.snapshotItem, { [styles.itemArchived]: isArchived })}
    >
      <div className={styles.itemName}>
        <Link to={to}>{snapshotDisplayName(snapshot)}</Link>
        {isArchived && (
          <div className={styles.itemArchivedLabel}>
            <Icon icon={faBoxArchive} className="icon archived icon-left" />
            Archived
          </div>
        )}
      </div>
      <div className={styles.snapshotMetadata}>
        <div>
          <Icon icon={faCalendarAlt} className="icon icon-left" />
          {formatWhen(snapshot.snapshot_at)}
        </div>
        <div>
          <Icon icon={faUsers} className="icon icon-left" />
          {snapshot.metadata?.team_count ?? 'Unknown'}
          {pluralize(snapshot.metadata?.team_count, ' team', ' teams')}
        </div>
        <div>
          <Icon icon={faCircleQuestion} className="icon icon-left" />
          {snapshot.metadata?.question_count}
          {pluralize(
            snapshot.metadata?.question_count,
            ' question',
            ' questions'
          )}
        </div>
      </div>
    </li>
  );
}
